import React from 'react';

const list = [
  ['jiuzhilan', 'zhaoxia', 'chuangliang', 'tuzi', 'yunthl', 'zhongtsj', 'qunyi', 'zhiling'],
  ['yutang', 'weisheng', 'lankuang', 'yunque', 'weimeng', 'changxun', 'duomeng', 'linkedme'],
  ['xianshi', 'hypers', 'convetlab', 'reyun', 'talkingdata', 'kaiyujituan', 'mianchao', 'getui'],
  ['xinbang', 'weiboll', 'yingtaoyun', 'xiongmxt', 'youju01', 'yixin01', 'weibanzs', 'jianf'],
  ['xiaolb', 'lingy'],
];

const Partners = () => {
  return (
    <section className="partners">
      <div className="fade text-bold header">我们的服务商伙伴</div>
      <div className="fade text-bold sub-header">SOFTWARE VENDORS</div>

      {list?.map((line, index) => (
        <div key={index} className="fade flex-list">
          {line.map((item) => (
            <img key={item} src={`https://union.gdtimg.com/webstore/partner-${item}.png`} alt="" />
          ))}
        </div>
      ))}
    </section>
  );
};

export default Partners;
